import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
} from '@ionic/react'

import { Card, CardContent } from '../../../components/ui/card'
import { useCheckInMethod } from '../../check-in-store'
import { useCheckIn, useClearActiveStationClients } from '../mutations'

import type { TerminalType } from '../paired.schema'
import { useToast } from '../../../contexts/toastContext'

type Props = {
  clientId: string
  onDismiss: () => void
  type: TerminalType
}

function BusyStationModal({ clientId, onDismiss, type }: Props) {
  const setToast = useToast()
  const checkInMethod = useCheckInMethod()

  const { mutate: checkIn } = useCheckIn()
  const { mutate: clearActiveStationClients } = useClearActiveStationClients()
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Oops!</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <Card>
          <CardContent>
            <p>There seems to be someone already checked in on this station.</p>
            <IonButton
              onClick={() => {
                clearActiveStationClients(undefined, {
                  onError: (error) => {
                    const errorMessage =
                      error instanceof Error ? error.message : 'Unknown Error'

                    setToast({
                      message: `Something went wrong clearing active stations. ${errorMessage}`,
                    })
                  },
                  onSuccess: () => {
                    checkIn({ checkInMethod, clientId, type })
                    onDismiss()
                  },
                })
              }}
            >
              Retry
            </IonButton>
          </CardContent>
        </Card>
      </IonContent>
    </IonPage>
  )
}

export { BusyStationModal }
